import * as log from 'loglevel';
import * as _ from "lodash"
import * as ko from 'knockout';
import {getPrimaryScreenVisibilityOptions} from "../ScreenVisibility";
import {ComputedOptions} from "~knockout/index";
import {Screen} from "../Screen";
import {showSecondaryScreen} from "../ScreenManager";
import {getGameManager} from "../../game/GameManager";
import {Observable} from '~knockout/index';
import {Computed} from "~knockout/index";
import {PureComputed} from "~knockout/index";
import {pauseScreenVisible} from './pause-menu/PauseOverlay';
import {toggleMute} from '../../game/audio/AudioManager';
import {transitionOut} from '../transition-overlay/TransitionOverlay';

var template = require('./GamePlayScreen.html');

class GamePlayScreenComponent extends Screen
{
    game: Phaser.Game;
    score: Observable<number>;
    progress: Observable<string>;
    currentLevel: Observable<number>;
    timeRemaining: PureComputed<string>;

    timeBonus: Observable<string>;
    visibleBonus: Observable<string>;
    showTimeBonus: Observable<boolean>;
    showvisibleBonus: Observable<boolean>;

    isMuted:  Observable<boolean>;

    /**
     * create knockout bindings
     */
    createBindings()
    {
        //  create super-class bindings

        super.createBindings();

        //  create game-specific bindings

        this.score = getGameManager().score;
        this.progress = getGameManager().progress;
        this.currentLevel = getGameManager().currentLevel;

        //  format time remaining

        this.timeRemaining = ko.pureComputed(this.getTimeRemaining);

        //  bonus observables

        //getGameManager().visibleBonus;
        this.visibleBonus = getGameManager().visibleBonus;
        this.isMuted = ko.observable(false);
        //this.showTimeBonus = getGameManager().showTimeBonus;
        //this.showvisibleBonus = getGameManager().showvisibleBonus;
    }


    /**
     * get screen visibility computed options
     * @returns {ComputedOptions<boolean>}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return getPrimaryScreenVisibilityOptions('gameplay');
    }


    /**
     * when we show the game screen, start the game
     */
    onShow()
    {
        getGameManager().playGame();

        //  show the game intro screen

        showSecondaryScreen('game-intro');

        //  reveal the game from behind the transition

        transitionOut(1000);

        //  show the pause menu

        pauseScreenVisible(false);
    }


    /**
     * convert time into a nicer format
     */
    getTimeRemaining()
    {
        var raw: number,
            seconds: string,
            minutes: number,
            timeRemaining: string;

        //  get the time remaining in seconds

        raw = getGameManager().timeRemaining();

        //  get minutes

        minutes = Math.max(Math.floor(raw / 60), 0);

        //  get seconds

        seconds = '' + Math.max((raw % 60), 0);

        if (seconds.length === 1) seconds = '0' + seconds;

        return minutes + ':' + seconds;
    };


    /**
     * show the menu, pausing the game
     */
    showMenu = () =>
    {
        log.debug('pausing the game');
        
        //  pause the game
        
        getGameManager().pauseGame();

        //  show the pause menu

        pauseScreenVisible(true);
    };


    /**
     * show the menu, pausing the game
     */
    toggleAudio()
    {
        this.isMuted(toggleMute());
    }
}





/**
 * register this component with knockout
 * @param vizID
 */
export function registerGameplayScreenComponent()
{
    ko.components.register('pp-gameplay',
        {
            viewModel: () => { return new GamePlayScreenComponent() },
            template: template
        });
}


// WEBPACK FOOTER //
// ./src/ts/screens/gameplay/GamePlayScreen.ts